import { subscription } from '../actions/types';
import RestClient from '../../api/axiosInterceptor';
import { API_URLS } from '../../api/endpoint';
import { updateActionErrors } from './updateActionErrors';

export const subscribeToNewsletter = async (action) => {
  const data = { email: action.payload.email };
  try {
    const response = await RestClient.post(API_URLS.subscribeToNewsletter, data);
    if (response.status !== 200) {
      return updateActionErrors(action, response.data.errors);
    } else {
      action.payload = {
        ...action.payload,
        message: 'Subscription successful'
      };
    }
  } catch (error) {
    return updateActionErrors(action, error);
  }
  return action;
};

export const subscriptionMiddleware = (storeAPI) => next => async (action) => {
  switch (action.type) {
    case subscription.SUBSCRIBE_TO_NEWSLETTER:
      action = await subscribeToNewsletter(action);
    default:
      break;
  }
  return next(action);
};
